import { createAction, props } from '@ngrx/store';
import { ClientMonitoring } from '@interfaces/control/monitoring/responses/client-monitoring.response';
import { MonitoringStatusColumn } from '@interfaces/control/monitoring/responses/monitoring-status.response';
import { MonitoringFilterDto } from '@interfaces/control/monitoring/requests/monitoring-filter.request';

// Load Clients
export const loadClients = createAction(
  '[Monitoring] Load Clients',
  props<{ filters: MonitoringFilterDto }>()
);

export const loadClientsSuccess = createAction(
  '[Monitoring] Load Clients Success',
  props<{ clients: ClientMonitoring[] }>()
);

export const loadClientsFailure = createAction(
  '[Monitoring] Load Clients Failure',
  props<{ error: string }>()
);

// Load Status Columns
export const loadStatusColumns = createAction('[Monitoring] Load Status Columns');

export const loadStatusColumnsSuccess = createAction(
  '[Monitoring] Load Status Columns Success',
  props<{ columns: MonitoringStatusColumn[] }>()
);

export const loadStatusColumnsFailure = createAction(
  '[Monitoring] Load Status Columns Failure',
  props<{ error: string }>()
);

// Update Client Status
export const updateClientStatus = createAction(
  '[Monitoring] Update Client Status',
  props<{ clientId: string; status: string }>()
);

export const updateClientStatusSuccess = createAction(
  '[Monitoring] Update Client Status Success',
  props<{ clientId: string; status: string }>()
);

export const updateClientStatusFailure = createAction(
  '[Monitoring] Update Client Status Failure',
  props<{ error: string }>()
);

// Clear All
export const clearAll = createAction('[Monitoring] Clear All');
